import { defineComponent } from '@ui/components/helpers';
import { componentBase } from '@ui/components/schemas';

export const icTopBarDefinition = defineComponent('ic-top-bar', {
  base: componentBase,

  description:
    'Barra superior del shell de la aplicación. Emite toggle en el botón de menú y agrupa la campana de notificaciones y el menú de sesión del usuario.',

  props: {},

  defaults: {},

  component: () =>
    import('./top-bar.component').then(m => m.IcTopBarComponent),
});
